import { useContext } from "react"
import CustomerContext from "../contexts/CustomerContext"

export function useCustomer() {
  return useContext(CustomerContext)
}
